module.exports = __webpack_public_path__ + "img/presentation.69ec0e68.svg";